export default __webpack_public_path__ + "static/media/plain-sticker-x.bf669cb1.png";